let service = {};

const listAllQuery = {
    pageNum: 0,
    pageSize: 99999
};

/**
 * 表单提交
 * @param vm         vue实例
 * @param url        请求地址
 * @param editFlag   是否为编辑
 * @param formInfo   表单信息
 * @param listRouter 跳转的List路由名称
 * @Auth wk 2019-03-13
 *  */
service.submitForm = function (vm, url, editFlag, formInfo, listRouter) {
    if (editFlag) {
        vm.$H.put(vm, url, formInfo, function (res) {
            vm.$U.success(vm, '保存成功');
            vm.$router.push({
                name: listRouter
            });
        });
    } else {
        vm.$H.post(vm, url, formInfo, function (res) {
            vm.$U.success(vm, '保存成功');
            vm.$router.push({
                name: listRouter
            });                                                                                  
        });
    }

};

/** 
 * 获取listAll
 * 
*/
service.getListAll = function (vm, url, callback) {
    vm.$H.get(vm, url, listAllQuery, callback);
};

// 判断用户按钮权限
service.getUserAuth = function(vm,page,fun){
    return true;
};

export default service;


// WEBPACK FOOTER //
// ./src/utils/service.js